var version = {
    "name":      "dativery",
    "buildDateCode": "20260501-182917",
    "buildDate": "Fri May 01 2026 18:29:17 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260501-182917",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;